export default __webpack_public_path__ + "static/media/tick.fea06a3b.svg";